import { Language, RegionType } from "graphql/generated";

export const companyNames = {
  [RegionType.Sg]: {
    noah: "Noah Health Pte. Ltd",
    zoey: "Zoey Health Pte. Ltd"
  },
  [RegionType.Hk]: {
    noah: "Noah & Zoey Limited"
  },
  [RegionType.Jp]: {
    noah: "Noah & Zoey Kabushiki Kaisha"
  }
};

export const companyAddress = "27 West Coast Highway #02-22 GH85 S117867";

const momentLocale = {
  [RegionType.Sg]: { [Language.En]: "en-US" },
  [RegionType.Hk]: { [Language.En]: "en-US", [Language.Zh]: "zh-CN" },
  [RegionType.Jp]: { [Language.En]: "en-US", [Language.Ja]: "ja" }
};

export const US_LOCALE = "en-US";

export const COUNTRY_TO_LANGUAGE = {
  [RegionType.Sg]: Language.En,
  [RegionType.Hk]: Language.Zh,
  [RegionType.Jp]: Language.Ja
};

export const LANGUAGE_TO_COUNTRY = {
  [Language.En]: RegionType.Sg,
  [Language.Zh]: RegionType.Hk,
  [Language.Ja]: RegionType.Jp
};

export const IS_PRODUCTION = process.env.NEXT_PUBLIC_PRODUCTION === "true";
export const ENABLE_AGORA_LOGGING = process.env.NEXT_PUBLIC_AGORA_LOGGING === "true";
export const MOMENT_LOCALE = (locale) => momentLocale[process.env.NEXT_PUBLIC_COUNTRY][locale];
export const MAX_VIDEO_CONSULT_SECONDS =
  parseInt(process.env.NEXT_PUBLIC_SESSION_MAX_MINUTES || "50", 10) * 60;
